module.exports = __webpack_public_path__ + "static/media/resume.3ca1c36a.jpg";